import { useLingui } from '@lingui/react/macro';
import React from 'react';
import InspectorRow from '../shared/inspector-row';
import InspectorSection from '../shared/inspector-section';
import NumberField from '../shared/number-field';
import { useCommonFabricProp } from '../shared/use-common-fabric-prop';
import type { ObjectInspectorProps } from '../types';

const TransformSection: React.FC<ObjectInspectorProps> = ({ objects, editor }) => {
  const { t } = useLingui();
  const MIXED = t`(разное)`;
  const left = useCommonFabricProp<number>(objects, 'left', editor);
  const top = useCommonFabricProp<number>(objects, 'top', editor);
  const width = useCommonFabricProp<number>(objects, 'width', editor);
  const height = useCommonFabricProp<number>(objects, 'height', editor);
  const angle = useCommonFabricProp<number>(objects, 'angle', editor);

  // X/Y are absolute coords; while many objects are wrapped in a fabric
  // ActiveSelection their left/top become selection-center-relative, so editing
  // them in bulk is meaningless. Show position only for a single selection —
  // group positioning is handled by drag + the Alignment section.
  const showPosition = objects.length === 1;

  return (
    <InspectorSection title={t`Трансформация`}>
      {showPosition && (
        <>
          <InspectorRow label="X">
            <NumberField value={left.value} onChange={left.setValue} />
          </InspectorRow>
          <InspectorRow label="Y">
            <NumberField value={top.value} onChange={top.setValue} />
          </InspectorRow>
        </>
      )}
      <InspectorRow label={t`Ширина`}>
        <NumberField
          value={width.isMixed ? undefined : width.value}
          onChange={width.setValue}
          min={1}
          placeholder={width.isMixed ? MIXED : undefined}
        />
      </InspectorRow>
      <InspectorRow label={t`Высота`}>
        <NumberField
          value={height.isMixed ? undefined : height.value}
          onChange={height.setValue}
          min={1}
          placeholder={height.isMixed ? MIXED : undefined}
        />
      </InspectorRow>
      <InspectorRow label={t`Угол`}>
        <NumberField
          value={angle.isMixed ? undefined : angle.value}
          onChange={angle.setValue}
          step={1}
          placeholder={angle.isMixed ? MIXED : undefined}
        />
      </InspectorRow>
    </InspectorSection>
  );
};

export default TransformSection;
